/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Price_ListInputs */

const en_field_price_list = /** @type {(inputs: Field_Price_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price list`)
};

/**
* | output |
* | --- |
* | "Price list" |
*
* @param {Field_Price_ListInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_price_list = /** @type {((inputs?: Field_Price_ListInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Price_ListInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_price_list(inputs)
});